import { useCallback, useEffect, useRef } from "react";
var useIntelligentTimer = function () {
    var current = useRef(null);
    var end = useRef(null);
    var start = useCallback(function (callback, time) {
        // If the requested time is less than the current time, do nothing
        var newEnd = Date.now() + time;
        if (end.current && newEnd < end.current)
            return;
        // If there's a timer, clear it
        if (current.current)
            clearTimeout(current.current);
        // Start the new timer
        end.current = newEnd;
        current.current = setTimeout(function () {
            callback();
            end.current = null;
        }, time);
    }, []);
    var stop = useCallback(function () {
        if (current.current)
            clearTimeout(current.current);
        end.current = null;
    }, []);
    useEffect(function () { return function () {
        if (current.current)
            clearTimeout(current.current);
    }; }, []);
    return [start, stop];
};
export default useIntelligentTimer;
